'use strict';

module.exports = require('./es6/crc16modbus').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc16_modbus.js
// module id = 761
// module chunks = 0